var se_myaccount = se_myaccount || {};
se_myaccount.Utils = {
    addNewAddress: function(){

    }
}
function js_RoundNumber(number) {
    var v = (number + "").replace(/,/g, "");
    var newnumber = parseFloat(v).toFixed(2);
    newnumber = newnumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    return newnumber;
}

function hideAllElements(elsContext){
    var elems = document.querySelectorAll(elsContext);
    [].forEach.call(elems, function(el) {
        if (el){
            el.style.display = 'none';
        }
    });
}

function hideElement(elContext){
    var el = document.querySelector(elContext);
    if (el){
        el.style.display = 'none';
    }
}

function showElement(elContext){
    var el = document.querySelector(elContext);
    if (el){
        el.style.display = 'block';
    }
}

function sendEvent(elContext, eventName){
    var el = document.querySelector(elContext);
    if (el){
        var event = new Event(eventName);
        el.dispatchEvent(event);
    }
}

function changeEmail() {
    //hideElement("#customer_orders");
    //hideElement("#admin_header");
    hideElement(".account--info");
    showElement(".account--change-email");
}

function validateChangeEmail() {
    var em = document.getElementById("newemail").value.trim();
    var em_again = document.getElementById("retypenewemail").value.trim();
    if (! em) {
        alert('Please input email address.');
        document.getElementById("newemail").focus();
        return false;
    } else {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
        if (! regex.test(em)) {
            alert('Invalid email address, please try again.');
            document.getElementById("newemail").focus();
            return false;
        }
    }

    if (! em_again) {
        alert('Please input confirm email address.');
        document.getElementById("retypenewemail").focus();
        return false;
    } else {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
        if (! regex.test(em_again)) {
            alert('Invalid confirm email address, please try again.');
            document.getElementById("retypenewemail").focus();
            return false;
        }
    }

    if (em != em_again) {
        alert('Please confirm email address again.');
        document.getElementById("retypenewemail").focus();
        return false;
    }
    return true;
}

function checkTeamStoreAcc(){

    if (Cookies.get('apitoken') != null) {
        if (ShopifyCustomerId != "" && ShopifyCustomerId != "0") {
            var myData = {
                'ShopifyCustomerID': ShopifyCustomerId
            };
            var url = SEEndpointURL + 'api/customer/checkteamstore?key=' + Math.random();

            var request = new XMLHttpRequest();			
            request.open('POST', url, true);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('apitoken', Cookies.get('apitoken'));
            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    var resp = this.response;
                    console.log('Success');
                    if (resp != null){       
                        var response = JSON.parse(resp);
                        if (response.Meta.message=="yes"){
                            showElement("#teamstore-link");
                        }
                    }
                } else {
                    // We reached our target server, but it returned an error
                    console.log(' We reached our target server, but it returned an error');
                    
                }
            };
            request.onerror = function(error) {
                // There was a connection error of some sort
                console.log('There was a connection error of some sort');
            };
            request.send(JSON.stringify(myData));

        }
    } else {
        console.log('token is null, can not verify this account');
    }

}

function submitChangeEmail(event) {
    event.preventDefault();
    event.stopPropagation();
    //$("#lblEmailError").fadeOut();
    //$("#lblEmailNotification").fadeOut();
    hideElement("#lblEmailError");
    hideElement("#lblEmailNotification");
    if (validateChangeEmail()) {
        var CustomerSubscription = false;
        if(document.getElementById("chkKeepUpToDate").checked){
            CustomerSubscription = true;
        }
        var myData = {
            'ShopifyCustomerID': ShopifyCustomerId,
            'action': 'changeEmail',
            'newEmail': document.getElementById("newemail").value.trim(),
            'CustomerSubscription':CustomerSubscription
        };
        var url = SEEndpointURL + 'api/customer/email?key=' + Math.random();

        var request = new XMLHttpRequest();			
        request.open('POST', url, true);
        request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
        request.setRequestHeader('apitoken', Cookies.get('apitoken'));
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                // Success!
                var resp = this.response;
                console.log('Success');
                if (resp != null){       
                    var response = JSON.parse(resp);
                    if (response.Meta.message == "success") {
                        document.getElementById("lblEmailNotification").innerHTML = " Your email address is updated successfully!";
                        //document.getElementById("currentEmail").textContent = document.getElementById("newemail").value.trim()
                        showElement("#lblEmailNotification");
                        hideElement("#lblEmailError");
                        setTimeout(function(){ window.location.href="/account?view=personal"; }, 2000);
                    } else {
                        document.getElementById("lblEmailError").innerHTML = response.Meta.message;
                        showElement("#lblEmailError");
                        hideElement("#lblEmailNotification");
                    }
                }
            } else {
                // We reached our target server, but it returned an error
                console.log(' We reached our target server, but it returned an error');
                
            }
        };
        request.onerror = function(error) {
            // There was a connection error of some sort
            console.log('There was a connection error of some sort');
        };
        request.send(JSON.stringify(myData));
    }
}

function LoyaltyProgram(){
    //hideAllElements(".myaccount-sections");
    showElement("#divPlusMembership");

    if (Cookies.get('apitoken') != null) {
        if (ShopifyCustomerId != "" && ShopifyCustomerId != "0") {
            var myData = {
                'ShopifyCustomerID': ShopifyCustomerId
            };
            var url = SEEndpointURL + 'api/customer/plusmembership?key=' + Math.random();

            var request = new XMLHttpRequest();			
            request.open('POST', url, true);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('apitoken', Cookies.get('apitoken'));
            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    var resp = this.response;
                    console.log('Success');
                    if (resp != null){       
                        var response = JSON.parse(resp);

                        document.querySelector('.membership_end_date').innerHTML = response.Data.t_UnsubDate;
                        document.querySelector('.membership_status_label').innerHTML = response.Data.s_Label;
                        
                        document.querySelector('.creditback_available').innerHTML = '$' + js_RoundNumber(response.Data.MembershipReward.AvailableStoreCreditBack);
                        document.querySelector('.creditback_pending').innerHTML = '$' + js_RoundNumber(response.Data.MembershipReward.PendingStoreCreditBack);
                        document.querySelector('.creditback_redeemed').innerHTML = '$' + js_RoundNumber(response.Data.MembershipReward.RedeemedStoreCreditBack);
                        document.querySelector('.creditback_earned').innerHTML = '$' + js_RoundNumber(response.Data.MembershipReward.EarnedStoreCreditBack);
                    }
                } else {
                    // We reached our target server, but it returned an error
                    console.log(' We reached our target server, but it returned an error');
                    
                }
            };
            request.onerror = function(error) {
                // There was a connection error of some sort
                console.log('There was a connection error of some sort');
            };
            request.send(JSON.stringify(myData));

        }
    } else {
        console.log('token is null, can not verify this account');
    }

}

function changeSubscription() {
    document.getElementById("customer_orders").style.display = 'none';
    if(document.getElementById("admin_header")!=null) document.getElementById("admin_header").style.display = 'none';
    document.getElementById("divChangeEmail").style.display = 'none';
    document.getElementById("divNewsletterSubscription").style.display = 'block';   
}
function backToMyAccount() {    
    document.getElementById("lblNotification").innerHTML = "";  
    document.getElementById("chkKeepUpToDate").checked = document.getElementById("hidEmailSubscription").value === 'true';    
    document.getElementById("newemail").value = "";
    document.getElementById("retypenewemail").value = "";    

    document.getElementById("customer_orders").style.display = 'block';
    if(document.getElementById("admin_header")!=null) document.getElementById("admin_header").style.display = 'block';
    document.getElementById("divNewsletterSubscription").style.display = 'none';      
    document.getElementById("divChangeEmail").style.display = 'none';
    document.getElementById("lblEmailError").style.display = 'none';
    document.getElementById("lblEmailNotification").style.display = 'none';      
    document.getElementById("lblEmailNotification").style.display = 'none';      
    hideElement("#divPlusMembership");
}
function toggleChk() {
    var chkKeepUpToDate = document.getElementById("chkKeepUpToDate");
    if (chkKeepUpToDate.checked)
        chkKeepUpToDate.checked = false;
    else
        chkKeepUpToDate.checked = true;      
}
function submitSubscription(event) {
    event.preventDefault();
    event.stopPropagation();
    document.getElementById("lblNotification").innerHTML = "";  
    document.getElementById("divSubLoading").style.display = 'block'; 
    var chkKeepUpToDate = document.getElementById("chkKeepUpToDate"); 
    var isSub = false;
    if (chkKeepUpToDate.checked) 
        isSub = true;
    
    var myData = {
        "FromSite": "SWIMOUTLET",
        "ShopifyCustomerID": ShopifyCustomerId,
        "ShopifyCustomerEmail": CustomerEmail,
        "CustomerSubscription": isSub
    };
    var url = SEEndpointURL + 'api/customer/subscription?key=' + Math.random();
    fetch(url, {
        method: 'POST', 
        headers: {
            'Content-Type': 'application/json',
            'apikey': Cookies.get('apikey'),
        },
        body: JSON.stringify(myData),
      })
    .then(
        function (response) {
            if (response.status !== 200) {
                console.log('Looks like there was a problem with submitSubscription(). Status Code: ' +
                response.status);
                return;
            }
            response.json().then(function (_data) {
                document.getElementById("divSubLoading").style.display = 'none'; 
                if (_data != null) {
                    document.getElementById("lblNotification").innerHTML =  _data.Data;
                    document.getElementById("hidEmailSubscription").value = isSub;
                } 
                else 
                    document.getElementById("lblNotification").innerHTML = "Your newsletter subscription was updated successfully!";
            });
        }
    )
    .catch(function (err) {
        console.log('Fetch Error :-S', err);
    });

}

function getGcByUser(custid, email) { // console.log('_cust:' + custid);
    if (Cookies.get('apitoken') != null) {
        if (custid != "" && custid != "0") {
            var myData = {
                'newEmail': email,
                'ShopifyCustomerID': custid,
                'action': 'getGiftCard',
                'fromSite': 'SWIMOUTLET'
            };
            var url = SEEndpointURL + 'api/product/giftcarduser?key=' + Math.random();

            var request = new XMLHttpRequest();			
            request.open('POST', url, true);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('apitoken', Cookies.get('apitoken'));
            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    var resp = this.response;
                    console.log('Success');
                    if (resp != null){       
                        var response = JSON.parse(resp);
                        var gcleft = response.Data.filter(function (d) {
                            return d.GiftAmountLeft > 0;
                        });
                        if (gcleft.length > 0) {
                            var amountleft = 0;
                            for (var i = 0; i < gcleft.length; i++) {
                                amountleft += parseFloat(gcleft[i].GiftAmountLeft);
                                // console.log('amountleft:' + amountleft);
                            }
                            document.querySelector('.store-credit-balance').innerHTML = '$' + js_RoundNumber(amountleft);
                        }
                    }
                } else {
                    // We reached our target server, but it returned an error
                    console.log(' We reached our target server, but it returned an error');
                    
                }
            };
            request.onerror = function(error) {
                // There was a connection error of some sort
                console.log('There was a connection error of some sort');
            };
            request.send(JSON.stringify(myData));

        }
    } else {
        console.log('token is null, can not verify this account');
    }
}

function redeemGC() {
    if (Cookies.get('apitoken') != null) {
        if (ShopifyCustomerId > 0) {
            var c1 = document.querySelector('[data-credit="first"]').value.trim();
            var c2 = document.querySelector('[data-credit="second"]').value.trim();
            var c3 = document.querySelector('[data-credit="third"]').value.trim();
            var GiftCardCode = (c1 + c2 + c3).replace(/-/g, "");
            if (GiftCardCode.length >= 10) {
                var myData = {
                    'shopifyEmail': CustomerEmail,
                    'shopifyCustId': ShopifyCustomerId,
                    'GiftCardCode': window.btoa(GiftCardCode),
                    'action': 'redeemGiftCard',
                    'fromSite': 'SWIMOUTLET'
                };
                var url = SEEndpointURL + 'api/product/redeemgiftcard?key=' + Math.random();

                var request = new XMLHttpRequest();			
                request.open('POST', url, true);
                request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                request.setRequestHeader('apitoken', Cookies.get('apitoken'));
                request.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        // Success!
                        var resp = this.response;
                        console.log('Success');
                        if (resp != null){       
                            var response = JSON.parse(resp);
                            if (response.Meta.message == "not_found") 
                                alert("Please enter a valid gift card");
                             else if (response.Meta.message == "already") 
                                alert("This gift card has already been applied to your account");
                             else {
                                getGcByUser(ShopifyCustomerId, CustomerEmail);
                                input_code();
                            }
                        }
                    } else {
                        // We reached our target server, but it returned an error
                        console.log(' We reached our target server, but it returned an error');
                        
                    }
                };
                request.onerror = function(error) {
                    // There was a connection error of some sort
                    console.log('There was a connection error of some sort');
                };
                request.send(JSON.stringify(myData));
            }
        }
    } else {
        console.log('token is null, can not verify this account');
    }
}
function input_code() {
    document.querySelector('[data-credit="new-giftcard"]').classList.toggle('d-inline-block');
    document.querySelector('input[data-credit]').value=''; // reset
    document.querySelector('[data-credit="show-input"]').classList.toggle('Button--primary--Active');
}

function documentReady(fn) {
    if (document.readyState != 'loading'){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}


var serialize = function (form) {
	var field,
		l,
		s = [];

	if (typeof form == 'object' && form.nodeName == "FORM") {
		var len = form.elements.length;

		for (var i = 0; i < len; i++) {
			field = form.elements[i];
			//if (field.name && !field.disabled && field.type != 'button' && field.type != 'file' && field.type != 'hidden' && field.type != 'reset' && field.type != 'submit') {
            if (field.name && !field.disabled && field.type != 'button' && field.type != 'file' && field.type != 'reset' && field.type != 'submit') {    
				if (field.type == 'select-multiple') {
					l = form.elements[i].options.length;

					for (var j = 0; j < l; j++) {
						if (field.options[j].selected) {
							s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
						}
					}
				}
				else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
					s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
				}
			}
		}
	}
	return s.join('&').replace(/%20/g, '+');
};

documentReady(function() {
    // code here
    // if(ShopifyCustomerId > 0){
    //     setTimeout(function(){
    //         checkTeamStoreAcc();
    //     }, 1000);//should run after verify token
    // }

    document.querySelectorAll('.order-product-more').forEach(btnViewMoreItems => btnViewMoreItems.addEventListener('click',function(){ // order list page
        this.parentElement.classList.toggle('expanded');
        if(this.querySelector('span').textContent == 'View More'){
            this.querySelector('span').textContent = 'View Less';
        }else{
            this.querySelector('span').textContent = 'View More';
        }
    }));

    if(ShopifyCustomerId > 0 && (window.location.search == '?view=storecredit' || window.location.search == '?view=payment')){
        setTimeout(function(){
            getGcByUser(ShopifyCustomerId, CustomerEmail);
        }, 1500);//should run after verify token
    }

    if(ShopifyCustomerId > 0 && window.location.search == '?view=membership'){
        setTimeout(function(){
            LoyaltyProgram()
        }, 1500);//should run after verify token
    }

    if(ShopifyCustomerId > 0 && (window.location.search.indexOf('view=personal') > 0) || window.location.pathname =='/account/addresses' ){ //Bind States and Country
        document.querySelectorAll('select[name ="address[country]"]').forEach(selectCountryBox => selectCountryBox.addEventListener('change',function(ele){
            if (this.getAttribute('data-default')){
                this.value = this.getAttribute('data-default');
            }
            var provincesData = this.options[this.selectedIndex].getAttribute('data-provinces');
            //console.log(provincesData);
            var selectEleProvinces = this.closest(".modal--address").querySelector('select[name ="address[province]"]');
            if (provincesData){
                var provincesJson = JSON.parse(provincesData);
                for(i = selectEleProvinces.options.length - 1; i >= 0; i--) {
                    selectEleProvinces.remove(i);
                }
                for(var i in provincesJson) {
                    //console.log(i, provincesJson[i]);
                    var isSelected = "";
                    if (selectEleProvinces.getAttribute('data-default') == provincesJson[i][0]){
                        isSelected = 'selected';
                    }
                    var opt = document.createElement('option');
                    opt.value = provincesJson[i][0];
                    opt.innerHTML = provincesJson[i][1];
                    opt.selected = isSelected;
                    selectEleProvinces.appendChild(opt);
                }
                selectEleProvinces.style.display='block';
            }else{
                selectEleProvinces.style.display='none';
            }
        }));

        document.querySelectorAll('.btn-del-addr').forEach(btnDelAddr => btnDelAddr.addEventListener('click',function(){
            document.querySelectorAll('.address-delete-form').forEach(formDelAddr =>formDelAddr.classList.remove('active'));
            this.closest('.address-delete-form').classList.add('active');
            showElement('#modal-address-delete');
            document.querySelector('.PageOverlay').classList.add('is-visible');
        }));

        document.querySelectorAll('.btn-edit-addr').forEach(btnEditAddr => btnEditAddr.addEventListener('click',function(){
            var addressIdModal = this.getAttribute('aria-controls');
            showElement('#'+addressIdModal);
            document.querySelector('.PageOverlay').classList.add('is-visible');
            sendEvent('#'+addressIdModal+ ' select[name ="address[country]"]','change');
        }));

        if(window.location.search.indexOf('view=personal') > 0){ // Prevent form submit on landing page
            // document.querySelectorAll('.address-delete-form').forEach(formDelAddr => formDelAddr.addEventListener('submit',function(event){ // Delete form
            //     event.preventDefault();
            //     //var dataForm = serialize(this);//"_method=delete";
            //     //console.log(dataForm);

            //     var url = this.getAttribute('action');
            //     var myData = {
            //         '_method': 'delete'
            //     };
            //     var request = new XMLHttpRequest();			
            //     request.open('POST', url, true);
            //     //request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
            //     request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            //     request.onload = function() {
            //         if (this.status >= 200 && this.status < 400) {
            //             // Success!
            //             var resp = this.response;
            //             console.log('Success');
            //             window.location = "/account?view=personal";
            //         } else {
            //             // We reached our target server, but it returned an error
            //             console.log(' We reached our target server, but it returned an error');
                        
            //         }
            //     };
            //     request.onerror = function(error) {
            //         // There was a connection error of some sort
            //         console.log('There was a connection error of some sort');
            //     };
            //     request.send(JSON.stringify(myData));    

            // }));

            document.querySelector('#address_form_new').addEventListener('submit',function(event){ // Register form to add new address - 
                event.preventDefault();
                var dataForm = serialize(this);
                //if (!document.getElementById("new-default-address").checked){
                    dataForm += "&address%5Bdefault%5D=2"; // Must have to add sucessfully, but the value is meaningless
                //}
                console.log(dataForm);

                var url = '/account/addresses' ;

                var request = new XMLHttpRequest();			
                request.open('POST', url, true);
                request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
                request.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        // Success!
                        var resp = this.response;
                        console.log('Success');
                        window.location = "/account?view=personal";
                    } else {
                        // We reached our target server, but it returned an error
                        console.log(' We reached our target server, but it returned an error');
                        
                    }
                };
                request.onerror = function(error) {
                    // There was a connection error of some sort
                    console.log('There was a connection error of some sort');
                };
                request.send(JSON.stringify(dataForm));

            });
        }
        
    }
    
    
});

